import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import { makeSelectValuesTimesheetEntryValue } from 'services/timesheetTimesheetEntriesForm/selectors';
import TimeOptions from '../../../../../../../../components/TimeOptions';
import TableCellRenderDropdown from '../TableCellRenderDropdown';

// Selectors

interface Props {
    endTime?: ?string;
}

export class StartTimeTableCellRenderDropdown extends React.PureComponent<Props> {
    render() {
        const { endTime } = this.props;

        return (
            <TimeOptions isStart endTime={endTime}>
                {options => (
                    <TableCellRenderDropdown
                        options={options}
                        {...this.props}
                    />
                )}
            </TimeOptions>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    endTime: makeSelectValuesTimesheetEntryValue('endTime')
});

export default connect(mapStateToProps)(StartTimeTableCellRenderDropdown);
